/**
 * orga-app-api - api-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MyIdentity { 
    fromEntraId?: boolean;
    fromHanko?: boolean;
    hankoUserId?: string;
    mail?: string;
    source?: string;
    sessionId?: string;
    authMethods?: Array<string>;
    isTrusted?: boolean;
}

